export { default as Screen } from "./Screen";
export type { ScreenBackground, ScreenProps } from "./Screen.types";
